import { sideOfKey } from './bookingFormParties';

// What one signature from this signatory goes onto — the agreement, its Inventory
// List (parties only: the list has no witness line) and, on the owner's side, their
// Letter of Undertaking. Mirrors the `documents` the servers give the signing page.
export const signedDocsFor = (form, key) => {
  if (!form || (form.form_type !== 'OTP' && form.form_type !== 'OTR')) return [];
  const side = sideOfKey(key);
  const witness = String(key || '').includes('witness');
  const docs = [form.form_type === 'OTR' ? 'Agreement to Rent' : 'Agreement to Purchase'];
  if (form.form_data?.include_inventory_list === true && !witness) docs.push('Inventory List');
  if ((side === 'owner' || side === 'landlord') && form.lou_included) docs.push('Letter of Undertaking');
  return docs;
};
